//designWidth:设计稿的实际宽度值，需要根据实际设置
//maxWidth:制作稿的最大宽度值，需要根据实际设置
//这段js的最后面有两个参数记得要设置，一个为设计稿实际宽度，一个为制作稿最大宽度，例如设计稿为750，最大宽度为750，则为(750,750)
(function (designWidth, maxWidth) {
    var doc = document,
        win = window,
        docEl = doc.documentElement,
        remStyle = document.createElement('style'),
        tid;

    // Mozilla/5.0 (Linux; Android 8.1.0; TYR300 Build/010100; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/77.0.3865.120 MQQBrowser/6.2 TBS/045332 Safari/537.36 AndroidBrowser/11.6.4.950 KidLearning_InApp_Android Apad
    // 为了兼容阿尔法蛋蛋的屏幕，针对这款屏幕给 window.designWidth / 2
    let TYRReg = /tyr\d+\sbuild/;
    let ua = window.navigator.userAgent.toLocaleLowerCase();
    if (TYRReg.test(ua) && ua.indexOf('apad') > -1) {
        window.designWidth /= 2;
    }

    function isPc() {
        var userAgentInfo = navigator.userAgent.toLocaleLowerCase();
        var Agents = ['android', 'iphone', 'symbianos', 'windows phone', 'ipad', 'ipod'];
        var flag = true;
        for (var v = 0; v < Agents.length; v++) {
            if (userAgentInfo.indexOf(Agents[v]) > 0) {
                flag = false;
                break;
            }
        }
        return flag;
    }

    function refreshRem() {
        var width = docEl.getBoundingClientRect().width;
        var currentDesignWidth = window.designWidth || designWidth;    // 防止每次 refresh 的时候原本的 designWidth 被改变

        if (isPc()) {
            if (!window.pcNeedSelfAdaption) {
                currentDesignWidth = window.devicePixelRatio * Math.max(1024, window.innerWidth);
            } else {
                maxWidth = window.devicePixelRatio * window.innerWidth;
                width = window.devicePixelRatio * docEl.getBoundingClientRect().width
                currentDesignWidth = window.devicePixelRatio * window.designWidth;
            }
        }
        maxWidth = maxWidth || 540;
        width > maxWidth && (width = maxWidth);
        var rem = (width * 100) / currentDesignWidth;
        console.log(width, currentDesignWidth)
        remStyle.innerHTML = 'html{font-size:' + rem + 'px;}';
        if (rem === 0) {   // 因为在ipad 7 上复现过获取宽度值为0，导致算出来的rem=0
            setTimeout(function () {
                maxWidth = window.devicePixelRatio * Math.min(window.innerWidth, window.innerHeight);
                refreshRem();
            }, 100)
        }
    }

    if (docEl.firstElementChild) {
        docEl.firstElementChild.appendChild(remStyle);
    } else {
        var wrap = doc.createElement('div');
        wrap.appendChild(remStyle);
        doc.write(wrap.innerHTML);
        wrap = null;
    }
    //要等 wiewport 设置好后才能执行 refreshRem，不然 refreshRem 会执行2次；
    refreshRem();

    win.addEventListener(
        'resize',
        function () {
            clearTimeout(tid); //防止执行两次
            tid = setTimeout(refreshRem, 300);
        },
        false
    );

    win.addEventListener(
        'pageshow',
        function (e) {
            if (e.persisted) {
                // 浏览器后退的时候重新计算
                clearTimeout(tid);
                tid = setTimeout(refreshRem, 300);
            }
        },
        false
    );

    if (doc.readyState === 'complete') {
        doc.body.style.fontSize = '18px';
    } else {
        doc.addEventListener(
            'DOMContentLoaded',
            function (e) {
                doc.body.style.fontSize = '18px';
            },
            false
        );
    }
})(window.designWidth || 750, window.devicePixelRatio * Math.min(window.innerWidth, window.innerHeight));



// WEBPACK FOOTER //
// ./src/lib/flexible.js